import { TranslationService } from './translationService';
import { GameService } from './gameService';
import { LevelService } from './levelService';
import { StateService } from './stateService';
import { AnalyticsService } from './analyticsService';

export const ALL_SERVICES = [
    TranslationService,
    GameService,
    LevelService,
    StateService,
    AnalyticsService,
];
